/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Unknown_DivisionInputs */

const th_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบดิวิชั่นนี้`)
};

const en_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That division does not exist.`)
};

const ja_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このディビジョンは存在しません。`)
};

const zh_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该分区不存在。`)
};

const es_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa categoría no existe.`)
};

const pt_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa categoria não existe.`)
};

const id_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisi itu tidak ada.`)
};

const fr_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette catégorie n’existe pas.`)
};

const tl_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ang dibisyong iyon.`)
};

const vi_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có bảng đó.`)
};

const ko_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그런 디비전은 없습니다.`)
};

const de_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Klasse gibt es nicht.`)
};

const ru_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого дивизиона нет.`)
};

const tr_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir grup yok.`)
};

const it_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quella categoria non esiste.`)
};

const pl_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taka grupa nie istnieje.`)
};

const uk_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Такого дивізіону немає.`)
};

const hi_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह वर्ग मौजूद नहीं है।`)
};

const ar_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلك الفئة غير موجودة.`)
};

const ms_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisyen itu tidak wujud.`)
};

const bn_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই বিভাগ নেই।`)
};

const zh_tw2_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該分組不存在。`)
};

const zh_hk2_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`該組別不存在。`)
};

const ur_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ درجہ موجود نہیں۔`)
};

const fa_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چنین گروهی وجود ندارد.`)
};

const sw_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daraja hilo halipo.`)
};

const nl_err_unknown_division = /** @type {(inputs: Err_Unknown_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die klasse bestaat niet.`)
};

/**
* | output |
* | --- |
* | "That division does not exist." |
*
* @param {Err_Unknown_DivisionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_unknown_division = /** @type {((inputs?: Err_Unknown_DivisionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Unknown_DivisionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_unknown_division(inputs)
	if (locale === "ja") return ja_err_unknown_division(inputs)
	if (locale === "zh") return zh_err_unknown_division(inputs)
	if (locale === "es") return es_err_unknown_division(inputs)
	if (locale === "pt") return pt_err_unknown_division(inputs)
	if (locale === "id") return id_err_unknown_division(inputs)
	if (locale === "fr") return fr_err_unknown_division(inputs)
	if (locale === "tl") return tl_err_unknown_division(inputs)
	if (locale === "vi") return vi_err_unknown_division(inputs)
	if (locale === "ko") return ko_err_unknown_division(inputs)
	if (locale === "de") return de_err_unknown_division(inputs)
	if (locale === "ru") return ru_err_unknown_division(inputs)
	if (locale === "tr") return tr_err_unknown_division(inputs)
	if (locale === "it") return it_err_unknown_division(inputs)
	if (locale === "pl") return pl_err_unknown_division(inputs)
	if (locale === "uk") return uk_err_unknown_division(inputs)
	if (locale === "hi") return hi_err_unknown_division(inputs)
	if (locale === "ar") return ar_err_unknown_division(inputs)
	if (locale === "ms") return ms_err_unknown_division(inputs)
	if (locale === "bn") return bn_err_unknown_division(inputs)
	if (locale === "zh-TW") return zh_tw2_err_unknown_division(inputs)
	if (locale === "zh-HK") return zh_hk2_err_unknown_division(inputs)
	if (locale === "ur") return ur_err_unknown_division(inputs)
	if (locale === "fa") return fa_err_unknown_division(inputs)
	if (locale === "sw") return sw_err_unknown_division(inputs)
	if (locale === "nl") return nl_err_unknown_division(inputs)
	return en_err_unknown_division(inputs)
});